export default "__VITE_ASSET__CvKpkKXZ__"